import React, { useState, useEffect } from 'react';
import './Style/DKDOffer.css';
import { DKDTnc } from './DKDTnC';

const apiBaseURL = process.env.REACT_APP_API_URL || `${window.location.origin}`;

export const DKDOffer = () => {
    const [activeTeb, setActiveTeb] = useState(null);
    const [loading, setLoading] = useState(true);
    const [leaderboard, setLeaderboard] = useState(true);
    const [leaderBoardStatus, setLeaderBoardStatus] = useState(true);
    const [leaderboardErrMsg, setLeaderboardErrMsg] = useState("");
    //const [dateString, setDateString] = useState("Oct 25, 2024 20:30:00");
    //const [isCountdownActive, setIsCountdownActive] = useState(false); 
    const [showLeaderBoard, setShowLeaderBoard] = useState(false); 
    const [countdownTime, setCountdownTime] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });
    //const [modalDataShow, setModalDataShow] = useState(null);

    //const getDKDLeaderboardDetails = () => {
    //    fetch(`${apiBaseURL}/api/DKD/GetDKDLeaderboardDetails`, {
    //        method: "GET",
    //        headers: {
    //            "Content-Type": "application/json"
    //        },
    //    })
    //    .then(response => {
    //        if (!response.ok) {
    //            throw new Error(`HTTP error! Status: ${response.status}`);
    //        }
    //        return response.json();
    //    })
    //        .then(resultInfo => {
    //            debugger;
    //        console.log("API Response6:", resultInfo);
    //        setLoading(false);
    //        setShowLeaderBoard(true);
    //        if (resultInfo && resultInfo.resultStatus === "Success") {
    //            setLeaderboard(resultInfo.result.leaderboardList);

    //            //dateString = resultInfo.Result[0].lastDate;
    //            return resultInfo.result.targetDate;
    //        }
    //        else if (resultInfo && resultInfo.resultStatus === "Failed") {
    //            setLeaderBoardStatus(false);
    //            setLeaderboardErrMsg(resultInfo.resultMessage);
    //            return 'Oct 25, 2024 19:07:00';
    //        }
    //    })
    //    .catch(err => {
    //        console.error("Error calling GenerateBulkSubscriptionRequest API:", err);
    //    });
    //}

    useEffect(() => {
        document.title = "DKD2024";
        let dateString = 'Nov 30, 2024 00:00:00';
        let countdownInterval = 0;
        let reloadCount = 1;
        let maxReloadCount = 3;

        const getDKDLeaderboardDetails = () => {
            let failedMsg = "";
            fetch(`${apiBaseURL}/api/DKD/GetDKDLeaderboardDetails`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                },
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(resultInfo => { 
                    //console.log("API Response6:", resultInfo);
                    if (resultInfo && resultInfo.resultStatus === "Success") {
                        setLeaderboard(resultInfo.result.leaderboardList);
                        if (resultInfo.result.leaderboardList && resultInfo.result.leaderboardList.length > 0) {
                            setLoading(false);
                            setShowLeaderBoard(true);
                        }
                        else { failedMsg = "reload" }

                        dateString = resultInfo.result.targetDate;
                    }
                    else if (resultInfo && resultInfo.resultStatus === "Failed") {
                        /*setLeaderBoardStatus(false);*/
                        failedMsg = resultInfo.resultMessage;
                        setLeaderboardErrMsg(failedMsg);
                    }
                })
                .catch(err => {
                    console.error("Error calling API:", err);
                })
                .finally(()=>{
                    startDKDTimer(failedMsg);
                });
        }

        const startDKDTimer = (failedMsg) => {
            const targetDate = new Date(dateString).getTime();
            //const targetDate = new Date('Nov 30, 2024 00:00:00').getTime();

            countdownInterval = setInterval(() => {
                const now = new Date().getTime();
                const timeLeft = targetDate - now;
                if (timeLeft < 0) {
                    if (failedMsg !== "" && failedMsg !== null && failedMsg !== "reload") {
                        setShowLeaderBoard(true);
                        setLeaderBoardStatus(false);
                    }
                    else if (failedMsg === "reload" && reloadCount <= maxReloadCount) {
                        reloadCount++;
                        getDKDLeaderboardDetails();
                    }
                    clearInterval(countdownInterval);
                    //setIsCountdownActive(true); // Countdown has ended
                } else {
                    // Calculate days, hours, minutes, and seconds
                    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
                    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
                    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

                    setCountdownTime({ days, hours, minutes, seconds });
                }
            }, 1000);
        }
        getDKDLeaderboardDetails();

        return () => clearInterval(countdownInterval); // Cleanup on unmount
    }, []);

    // Handle Teb click
    const handleTebClick = (tebId) => {
        setActiveTeb((prevActive) => (prevActive === tebId ? null : tebId)); // Toggle active state
    };

    // Handle Modal click
    const handleModalClick = (e) => {
        e.preventDefault();
        //setModalDataShow((prevModal) => (prevModal === modalId ? null : modalId)); // Toggle modal state
        document.body.classList.toggle('showmodal'); // Toggle body class
    };

    // Handle toggle countdown section
    //const handleToggleCountdown = () => {
    //    setIsCountdownActive(!isCountdownActive); // Toggle countdown section active state
    //};

    // Handle toggle countdown section
    //const handleToggleLeaderBoard = () => {
    //    setShowLeaderBoard(prv => !prv);
    //    document.body.classList.toggle('active'); // Toggle body class
    //};



    return (
        <div className="main-DKD">
            <header className="main-header">
                <div className="container">
                    {/*<div className="row align-items-center justify-content-between">*/}
                        <div className="logo-align">
                        <div className="a-logo-col">
                            <a href="https://www.watcho.com/">
                                <img src="Images/DKDOffer/logo.svg" alt="watcho"/>
                            </a>
                        </div>
                    </div>
                </div>
            </header>
            <div className="a-mobile-overlay menuActione"></div>
            <div className="mobile-header">
                <a href="#!" className="menuActione close">
                    <img src="Images/DKDOffer/close.svg" alt="close"/>
                </a>

                <div className="mobile-menus">
                    <ul className="data-nev">
                        <li className="a-nev-links" id="home">
                            <a href="/">Home</a>
                        </li>
                        <li className="a-nev-links" id="projects">
                            <a href="projects.php">Projects</a>
                        </li>
                        <li className="a-nev-links" id="aboutus">
                            <a href="about-us.php">About Us</a>
                        </li>
                        <li className="a-nev-links" id="careers">
                            <a href="careers.php">Careers</a>
                        </li>
                        <li className="a-nev-links" id="contactus">
                            <a href="contact-us.php">Contact Us <img src="Images/DKDOffer/right.svg"
                                alt=""/></a>
                        </li>
                    </ul>
                </div>
            </div>

            <main className="page-wrapper">
                <section className="home-banner">
                    <div className="image">
                        <img src="Images/DKDOffer/DKDBannerNew-1920x529.jpg" className="dextop-v" alt=""/>
                        <img src="Images/DKDOffer/DKDMobBanner-360x420.jpg" className="mobile-v" alt=""/>
                    </div>
                </section>
                        <section className="main-sections home-prizes-section">
                            <div className="container">
                                <div className="row justify-content-between align-items-end">
                                    <div className="col-sm-12 col-md-12 col-lg-5">
                                        <div className="prizes-card">
                                            <div className="prizes-card-body">
                                                <h3>Enter the Lucky Draw & Win Exciting Bumper Prizes! 🎁 </h3>
                                                <h5>Download the Watcho app, register your account, and get a chance to WIN bumper
                                                    prizes!</h5>
                                                <div className="btn-box">
                                            <a href="https://lets.watcho.com/dkd" target="_blank" rel="noreferrer" className="btn btn-primary-DKD" >Download App</a>
                                        </div>
                                        <div className="text">
                                            <h6>Offer Valid till 20th November 2024s</h6>
                                            <p onClick={handleModalClick}>
                                                <a className="copenModal" dataid="data1">Terms & Conditions applied</a>
                                            </p>
                                        </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-12 col-lg-6">
                                        <div className="image-mobile">
                                            <img src="./Images/DKDOffer/section1.svg" alt=""/>


                                        </div>
                                        <p className="onlymobile text-center">*Images are purely representative</p>

                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className="main-sections home-countdown-section ">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-sm-12 col-md-12 col-lg-8">
                                {!showLeaderBoard &&
                                    <div className="countdown-card">
                                        <div className="countdown-card-body">
                                            <div id="countdown">
                                                <ul>
                                                    <li><span id="days">{countdownTime.days}</span> <small>Days</small></li>
                                                    <li><span id="hours">{countdownTime.hours}</span> <small>Hours </small></li>
                                                    <li><span id="minutes">{countdownTime.minutes}</span> <small>Minutes </small></li>
                                                    <li><span id="seconds">{countdownTime.seconds}</span> <small>Seconds </small></li>
                                                </ul>
                                            </div>
                                            <h4><span>The Countdown Begins: </span> Bumper Offer Winner Leaderboard Revealed Soon
                                            </h4>
                                            <p>The wait is almost over! Our Bumper Offer's winner leaderboard will be revealed on
                                                November 30th. Stay tuned to see who's taking home the big prize!
                                            </p>
                                            <div className="btn-box">
                                                {/*<a className="btn btn-primary-DKD openTebal" onClick={handleToggleLeaderBoard}>Download App</a>*/}
                                                <a href="https://lets.watcho.com/dkd" target="_blank" rel="noreferrer" className="btn btn-primary-DKD openTebal" >Download App</a>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {showLeaderBoard &&
                                    <div className="countdown-result">
                                        <div className="countdown-result-card">
                                            <h4>Check <span>Winner’s</span> Bumper Lucky Draw Leaderboard!</h4>
                                            {leaderBoardStatus ?
                                                <div className="aj-responsive">
                                                    <table>
                                                        <thead>
                                                            <tr>
                                                                <th>Level</th>
                                                                <th>Winner Name</th>
                                                                <th>Gift</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {leaderboard && leaderboard.length>0 && leaderboard.map((dt,idx) =>
                                                                <tr key={idx }>
                                                                    <td>
                                                                        {idx === 0 ?
                                                                            <img src="./Images/DKDOffer/win-1.svg" alt="" />
                                                                            : idx === 1 ?
                                                                                <img src="./Images/DKDOffer/win-2.svg" alt="" />
                                                                                : idx === 2 ?
                                                                                    <img src="./Images/DKDOffer/win-3.svg" alt="" />
                                                                                    : dt.level.padStart(3, '0')
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        <b>{dt.winnerName}</b>
                                                                        <small>{dt.winnerMobNo}</small>
                                                                    </td>
                                                                    <td>
                                                                        <b>{dt.gift}</b>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                            {/*<tr>*/}
                                                            {/*    <td>*/}
                                                            {/*        <img src="./Images/DKDOffer/win-2.svg" alt="" />*/}
                                                            {/*    </td>*/}
                                                            {/*    <td>*/}
                                                            {/*        */}{/*<b>Rakesh Rai</b>*/}
                                                            {/*        */}{/*<small>99XXXXXX333</small>*/}
                                                            {/*        <b>{leaderboard[1].WinnerName}</b>*/}
                                                            {/*        <small>{leaderboard[1].WinnerMobNo}</small>*/}
                                                            {/*    </td>*/}
                                                            {/*    <td>*/}
                                                            {/*        */}{/*<b>Pulsar</b>*/}
                                                            {/*        <td><b>{leaderboard[0].Gift}</b></td>*/}
                                                            {/*    </td>*/}
                                                            {/*</tr>*/}
                                                            {/*<tr>*/}
                                                            {/*    <td>*/}
                                                            {/*        <img src="./Images/DKDOffer/win-3.svg" alt="" />*/}
                                                            {/*    </td>*/}
                                                            {/*    <td>*/}
                                                            {/*        */}{/*<b>Sujeet Singh</b>*/}
                                                            {/*        */}{/*<small>99XXXXXX333</small>*/}
                                                            {/*        <b>{leaderboard[2].WinnerName}</b>*/}
                                                            {/*        <small>{leaderboard[2].WinnerMobNo}</small>*/}
                                                            {/*    </td>*/}
                                                            {/*    <td>*/}
                                                            {/*        */}{/*<b>iphone</b>*/}
                                                            {/*        <td><b>{leaderboard[0].Gift}</b></td>*/}
                                                            {/*    </td>*/}
                                                            {/*</tr>*/}
                                                            {/*<tr>*/}
                                                            {/*    <td>004</td>*/}
                                                            {/*    <td>*/}
                                                            {/*        <b>Satya</b>*/}
                                                            {/*        <small>99XXXXXX333</small>*/}
                                                            {/*    </td>*/}
                                                            {/*    <td>*/}
                                                            {/*        <b>TV 55’ Inch</b>*/}
                                                            {/*    </td>*/}
                                                            {/*</tr>*/}
                                                            {/*<tr>*/}
                                                            {/*    <td>005</td>*/}
                                                            {/*    <td>*/}
                                                            {/*        <b>Dheeru</b>*/}
                                                            {/*        <small>99XXXXXX333</small>*/}
                                                            {/*    </td>*/}
                                                            {/*    <td>*/}
                                                            {/*        <b>Split AC</b>*/}
                                                            {/*    </td>*/}
                                                            {/*</tr>*/}
                                                            {/*<tr>*/}
                                                            {/*    <td>006</td>*/}
                                                            {/*    <td>*/}
                                                            {/*        <b>Dheeru</b>*/}
                                                            {/*        <small>99XXXXXX333</small>*/}
                                                            {/*    </td>*/}
                                                            {/*    <td>*/}
                                                            {/*        <b>laptop</b>*/}
                                                            {/*    </td>*/}
                                                            {/*</tr>*/}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                :
                                                <div className="aj-responsive">{leaderboardErrMsg}</div>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </section>
                <section className="main-sections home-faq-section">
                    <div className="container">
                        <div className="headding-span">
                            <h3>FAQ’s</h3>
                        </div>
                        <div className="tebBar-box">

                            <div className={`tebBar-card ${activeTeb === 'faq1' ? 'active' : ''}`}>
                                <div className={`tebActione ${activeTeb === 'faq1' ? 'active' : ''}`} tebopen="faq1" onClick={() => handleTebClick('faq1') }>
                                    <p>How do I participate in the lucky draw?</p>
                                </div>
                                <div className="disc-box divOpen" id="faq1" style={{ display: `${activeTeb === 'faq1' ? 'block' : ''}` }} >
                                    <div>
                                        <ul>
                                            <li>You need to do any transaction and then download Watcho App & register. If you are already registered, you need to recharge to participate.</li>
                                            {/*<li>Easy Setup: Choose DishTV directly from your TV</li>*/}
                                            {/*<li>Complimentary Service: Enjoy 30days of complimentary live TV channels as well as*/}
                                            {/*    OTT apps with Dish TV subscription</li>*/}
                                            {/*<li>Live TV Channels and OTT apps with a single subscription: All your entertainment*/}
                                            {/*    needs are covered with Dish TV’s plan.</li>*/}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className={`tebBar-card ${activeTeb === 'faq2' ? 'active' : ''}`}>
                                <div className={`tebActione ${activeTeb === 'faq2' ? 'active' : ''}`} tebopen="faq2" onClick={() => handleTebClick('faq2')}>
                                    <p>What is the start and end date of DKD offer?</p>
                                </div>
                                <div className="disc-box divOpen" id="faq2" style={{ display: `${activeTeb === 'faq2' ? 'block' : ''}` }} >
                                    <div>
                                        <ul>
                                            <li>Start date is 8th Oct 2024 and will run for 45 days.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className={`tebBar-card ${activeTeb === 'faq3' ? 'active' : ''}`}>
                                <div className={`tebActione ${activeTeb === 'faq3' ? 'active' : ''}`} tebopen="faq3" onClick={() => handleTebClick('faq3')}>
                                    <p>Do I need to recharge with any specific price/min recharge to get the benefits and participate in the lucky draw?</p>
                                </div>
                                <div className="disc-box divOpen" id="faq3" style={{ display: `${activeTeb === 'faq3' ? 'block' : ''}` }}>
                                    <div>
                                        <ul>
                                            <li>There is no min recharge value. The recharge value will be equivalent to the plan value. You just need to make a transaction and download and register Watcho App.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className={`tebBar-card ${activeTeb === 'faq4' ? 'active' : ''}`}>
                                <div className={`tebActione ${activeTeb === 'faq4' ? 'active' : ''}`} tebopen="faq4" onClick={() => handleTebClick('faq4')}>
                                    <p>Customers on Auto renewal will be eligible for lucky draw or not?</p>
                                </div>
                                <div className="disc-box divOpen" id="faq4" style={{ display: `${activeTeb === 'faq4' ? 'block' : ''}` }}>
                                    <div>
                                        <ul>
                                            <li>PGAR Users are eligible for Lucky draw provided their recharge is scheduled during this time frame</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className={`tebBar-card ${activeTeb === 'faq5' ? 'active' : ''}`}>
                                <div className={`tebActione ${activeTeb === 'faq5' ? 'active' : ''}`} tebopen="faq5" onClick={() => handleTebClick('faq5')}>
                                    <p>Can customer appear multiple times under lucky draw, if he recharges his account multiple time during the offer period?</p>
                                </div>
                                <div className="disc-box divOpen" id="faq5" style={{ display: `${activeTeb === 'faq5' ? 'block' : ''}` }}>
                                    <div>
                                        <ul>
                                            <li>There will be only one mega lucky draw and he can only participate once and it is unique participation</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className={`tebBar-card ${activeTeb === 'faq6' ? 'active' : ''}`}>
                                <div className={`tebActione ${activeTeb === 'faq6' ? 'active' : ''}`} tebopen="faq6" onClick={() => handleTebClick('faq6')}>
                                    <p>How do I know that I have won the prize? Will I get any confirmation msgs or any mail?</p>
                                </div>
                                <div className="disc-box divOpen" id="faq6" style={{ display: `${activeTeb === 'faq6' ? 'block' : ''}` }}>
                                    <div>
                                        <ul>
                                            <li>Yes</li>
                                        </ul>
                                    </div>
                                </div>
                            </div><div className={`tebBar-card ${activeTeb === 'faq7' ? 'active' : ''}`}>
                                <div className={`tebActione ${activeTeb === 'faq7' ? 'active' : ''}`} tebopen="faq7" onClick={() => handleTebClick('faq7')}>
                                    <p>If any customer wins CAR or Bike in lucky draw, how will winners get their prize delivered?</p>
                                </div>
                                <div className="disc-box divOpen" id="faq7" style={{ display: `${activeTeb === 'faq7' ? 'block' : ''}` }}>
                                    <div>
                                        <ul>
                                            <li>Winner of the Lucky Draws shall be responsible for the collection of the Prizes or to take delivery of the prizes upon furnishing documents (valid government ID - Aadhar Card, PAN Card, Passport) and for payment of applicable taxes as instructed by the Company. The Company reserves the right to disqualify/forfeit a winner if satisfactory documents are not furnished or applicable taxes is not paid by a winner. Winner will be required to share other documents to the Company to ascertain identity or otherwise. Winners must collect their prizes from the location specified in the communication from the Company The Winner shall be solely responsible for ensuring that he has valid driving documents and other documents as may be required for the registration of any prize which is a vehicle in the name of the winner.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div><div className={`tebBar-card ${activeTeb === 'faq8' ? 'active' : ''}`}>
                                <div className={`tebActione ${activeTeb === 'faq8' ? 'active' : ''}`} tebopen="faq8" onClick={() => handleTebClick('faq8')}>
                                    <p>Will the mega prize winners name will be visible on our website?</p>
                                </div>
                                <div className="disc-box divOpen" id="faq8" style={{ display: `${activeTeb === 'faq8' ? 'block' : ''}` }}>
                                    <div>
                                        <ul>
                                            <li>Yes</li>
                                        </ul>
                                    </div>
                                </div>
                            </div><div className={`tebBar-card ${activeTeb === 'faq9' ? 'active' : ''}`}>
                                <div className={`tebActione ${activeTeb === 'faq9' ? 'active' : ''}`} tebopen="faq9" onClick={() => handleTebClick('faq9')}>
                                    <p>Currently I am a paid subscriber of Watcho Max/South Max plan, am I also eligible for this free sampling?</p>
                                </div>
                                <div className="disc-box divOpen" id="faq9" style={{ display: `${activeTeb === 'faq9' ? 'block' : ''}` }}>
                                    <div>
                                        <ul>
                                            <li>No he will not be eligible</li>
                                        </ul>
                                    </div>
                                </div>
                            </div><div className={`tebBar-card ${activeTeb === 'faq10' ? 'active' : ''}`}>
                                <div className={`tebActione ${activeTeb === 'faq10' ? 'active' : ''}`} tebopen="faq10" onClick={() => handleTebClick('faq10')}>
                                    <p>What is the validity of Watcho coupon for Watcho paid plan users?</p>
                                </div>
                                <div className="disc-box divOpen" id="faq10" style={{ display: `${activeTeb === 'faq10' ? 'block' : ''}` }}>
                                    <div>
                                        <ul>
                                            <li>Coupon validity will be till 20th November</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
            </main>

            <div className="modalbody" >
                <div className="copenModal modalbg" onClick={handleModalClick}></div>
                <div className="Cmodalcard">
                    <div className="maincontentmodal">
                        <DKDTnc handleModalClick={handleModalClick} />
                        {/*<div className="modalheader">*/}
                        {/*    <h3>Terms & Conditions</h3>*/}
                        {/*    <span className="copenModal cmodalclose" onClick={handleModalClick}>*/}
                        {/*        <span></span>*/}
                        {/*    </span>*/}
                        {/*    */}{/*<a href="#!" className="copenModal cmodalclose"><span onClick={(e) => handleModalClick(e,"")}></span></a>*/}
                        {/*</div>*/}
                        {/*<div className="modaldatashow show" id="data1">*/}
                        {/*    <div className="content">*/}
                        {/*        <div className="text">*/}
                        {/*            <p><b>Eligibility</b></p>*/}
                        {/*            <ul>*/}
                        {/*                <li>The lucky draw is open to all users who have subscribed to [specific service/offer].*/}
                        {/*                </li>*/}
                        {/*                <li>Exclusions: Users with deactivated accounts, corporate plans, or those ineligible*/}
                        {/*                    based*/}
                        {/*                    on specific conditions.</li>*/}
                        {/*                <li>Users must have an active account during the draw period.</li>*/}
                        {/*            </ul>*/}
                        {/*            <p><b>How to Participate</b></p>*/}
                        {/*            <ul>*/}
                        {/*                <li>No additional steps required! If you’re eligible, you’ll automatically be entered*/}
                        {/*                    into*/}
                        {/*                    the draw.</li>*/}
                        {/*                <li>Stay subscribed to the relevant service during the draw period.</li>*/}
                        {/*            </ul>*/}
                        {/*            <p><b>Prizes</b></p>*/}
                        {/*            <ul>*/}
                        {/*                <li>Exciting prizes like smartphones, smart TVs, gift vouchers, and more are up for*/}
                        {/*                    grabs!*/}
                        {/*                </li>*/}
                        {/*                <li>Prizes will be awarded randomly to lucky winners at the end of the promotion period.*/}
                        {/*                </li>*/}
                        {/*            </ul>*/}
                        {/*            <p><b>Prizes</b></p>*/}
                        {/*            <ul>*/}
                        {/*                <li>Exciting prizes like smartphones, smart TVs, gift vouchers, and more are up for*/}
                        {/*                    grabs!*/}
                        {/*                </li>*/}
                        {/*                <li>Prizes will be awarded randomly to lucky winners at the end of the promotion period.*/}
                        {/*                </li>*/}
                        {/*            </ul>*/}
                        {/*            <p><b>Prizes</b></p>*/}
                        {/*            <ul>*/}
                        {/*                <li>Exciting prizes like smartphones, smart TVs, gift vouchers, and more are up for*/}
                        {/*                    grabs!*/}
                        {/*                </li>*/}
                        {/*                <li>Prizes will be awarded randomly to lucky winners at the end of the promotion period.*/}
                        {/*                </li>*/}
                        {/*            </ul>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>
                </div>
            </div>

            <footer className="footer-section">
                <div className="footer-content">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-sm-12 col-md-12 col-lg-6 ">
                                <div className="content">
                                    <div className="text">
                                        <p>©2019 Watcho. All Rights Reserved. www.watcho.com or abbreviated Watcho is an online
                                            video streaming service where visitors can access a variety of films, web series, Live
                                            TV serials, user generated content, etc., for which viewing rights are given by content
                                            copyright holders. Watcho and all related channel and programming logos are service
                                            marks of, and all related programming audio-visuals and elements are the property of
                                            Dish Infra Services Private Limited.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-6 ">
                                <div className="platfom-footer-logos">
                                    <ul>
                                        <li>TV Platforms</li>
                                        <li>
                                            <div className="image">
                                                    <a target="_blank" rel="noreferrer" href="https://ind01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.watcho_multi&data=05%7C02%7Csunilkumar.singh.it%40d2hdesk.com%7C3b474342a5c441fe441708dce1e35f86%7C2b974f695cb84d58ae71c7d3f88e454e%7C0%7C0%7C638633613921629696%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&sdata=HWc2lqNoCI%2Bcc8Z%2B%2BPiJPZv4geUGUgdl4afUWrzIYyM%3D&reserved=0">
                                                <img src="Images/DKDOffer/f-logo1.svg" alt="" />
                                                </a>
                                            </div>
                                            <div className="image">
                                                <a target="_blank" rel="noreferrer" href="https://ind01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fwww.amazon.in%2FWatcho-Original-Spotlight-Exclusive-Shows%2Fdp%2FB07XPG5FW5&data=05%7C02%7Csunilkumar.singh.it%40d2hdesk.com%7Ca2f0a735c90c41f989a008dce75865ed%7C2b974f695cb84d58ae71c7d3f88e454e%7C0%7C0%7C638639614099960778%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&sdata=qUFxHyACDUi0X8bR2kyd93%2Bp29MYaSwFAFIoncjq1to%3D&reserved=0">
                                                    <img src="Images/DKDOffer/f-logo2.svg" alt="" />
                                                </a>
                                            </div>
                                    <div className="image">
                                                <a target="_blank" rel="noreferrer" href="https://ind01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fapps.apple.com%2Fin%2Fapp%2Fwatcho-new-web-series-livetv%2Fid1440733653%3Fplatform%3DappleTV&data=05%7C02%7Csunilkumar.singh.it%40d2hdesk.com%7C3b474342a5c441fe441708dce1e35f86%7C2b974f695cb84d58ae71c7d3f88e454e%7C0%7C0%7C638633613921647310%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&sdata=k9hbgGbarb8nkl9cpto5zL6tFyKH3OwNhpMXAh60rI4%3D&reserved=0">
                                                    <img src="Images/DKDOffer/f-logo3.svg" alt="" />
                                                </a>
                                            </div>
                                    <div className="image">
                                        <a target="_blank" rel="noreferrer" href="https://www.samsung.com/levant/tvs/smart-tv/smart-hub-and-apps/">
                                            <img src="Images/DKDOffer/f-logo4.svg" alt="" />
                                        </a>
                                                        
                                            </div>
                                    <div className="image">
                                        <a target="_blank" rel="noreferrer" href="https://in.lgappstv.com/main/tvapp/detail?appId=1227441">
                                            <img src="Images/DKDOffer/f-logo5.svg" alt="" />
                                                </a>
                                            </div>
                                        </li>
                                    </ul>
                                    <ul>
                                        <li>Mobile Platforms</li>
                                        <li>
                                    <div className="image">
                                        <a target="_blank" rel="noreferrer" href="https://apps.apple.com/in/app/watcho-original-web-shows/id1440733653">
                                            <img src="Images/DKDOffer/f-logo6.svg" alt="" />
                                                </a>
                                            </div>
                                    <div className="image">
                                        <a target="_blank" rel="noreferrer" href="https://play.google.com/store/apps/details?id=com.watcho">
                                            <img src="Images/DKDOffer/f-logo7.svg" alt="" />
                                                </a>
                                            </div>
                                        </li>
                                    </ul>
                                    <ul>
                                        <li>Set-Top- Box</li>
                                        <li>
                                    <div className="image">
                                        <a target="_blank" rel="noreferrer" href="https://www.dishtv.in/">
                                            <img src="Images/dishTV-logo_New.png" alt="" />
                                                </a>
                                            </div>
                                    <div className="image">
                                        <a target="_blank" rel="noreferrer" href="https://www.d2h.com/">
                                            <img src="Images/DKDOffer/f-logo9.svg" alt="" />
                                                </a>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="social-menu">
                    <div className="container">
                        <div className="social-menu">
                            <div className="card-n">
                                <ul className="data-nev">

                            <li className="a-nev-links" id="projects">
                                <a href="https://www.watcho.com/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a>
                            </li>
                            <li className="a-nev-links copenModal" dataid="data1" id="termsConditions">
                                <a href="https://www.watcho.com/terms-use" target="_blank" rel="noreferrer">Terms &
                                    Conditions</a>
                            </li>
                            <li className="a-nev-links" id="swagTerms"><a href="https://www.watcho.com/terms-use" target="_blank" rel="noreferrer">Swag Terms</a></li>
                            <li className="a-nev-links" id="grievance"><a href="https://www.watcho.com/grievance" target="_blank" rel="noreferrer">Grievance</a></li>
                            <li className="a-nev-links" id="cookies"><a href="https://www.watcho.com/cookies" target="_blank" rel="noreferrer">Cookies</a></li>
                            <li className="a-nev-links" id="aboutus"><a href="https://www.watcho.com/about-us" target="_blank" rel="noreferrer">About Us</a></li>
                            <li className="a-nev-links" id="faqs"><a href="https://faq.watcho.com/" target="_blank" rel="noreferrer">FAQ's</a></li>
                        </ul>
                    </div>
                    <div className="social-links">
                        <ul>
                            <li>Connect with us :</li>
                                    <li><a target="_blank" rel="noreferrer" href="https://www.facebook.com/LetsWatcho/" className=""> <i className="fab fa-facebook" aria-hidden="true"></i></a></li>
                            <li><a target="_blank" rel="noreferrer" href="https://www.instagram.com/watchoapp/" className=""><i className="bi bi-instagram"></i></a></li>
                            <li><a target="_blank" rel="noreferrer" href="https://x.com/watchoapp" className=""><i className="bi bi-twitter"></i></a></li>
                            <li><a target="_blank" rel="noreferrer" href="https://www.youtube.com/channel/UCs_VbCkjjq5x5yGFgY6tAPg" className=""><i className="bi bi-youtube"></i></a></li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </footer>

        </div>
    );
}